import React, {useMemo} from "react";
import router, {Route} from "@/routing/Router";
import {useIntl} from "react-intl";
import AdminLayout from "@widgets/layout/AdminLayout";
import {PageHeading} from "peggirkit";
import {generateBreadcrumbs} from "@widgets/layout/Breadcrumbs";
import DashboardLinks from "@widgets/dashboard/links/DashboardLinks";
import {posMenuSections} from "@widgets/layout/menu/MenuItems";


const PosDashboardHome = () => {
    const intl = useIntl();
    const route: Route = useMemo(() => router.posAdminDashboardHome, []);

    return (
        <AdminLayout currentPage={route}>
            <PageHeading
                breadcrumbs={generateBreadcrumbs(route, intl)}
                title={route.name(intl)}
            />

            <DashboardLinks menuSections={posMenuSections}/>
        </AdminLayout>
    );
};

export default PosDashboardHome;